import React from 'react';
import Markdown from 'react-remarkable';
import Weather from './Weather';
import {trans} from './utils';


export default class About extends React.Component {

  render () {
    let {lang, about, weather} = this.props;

    return (
      <div className="About">
        <Weather weather={weather} />
        <div className="Markdown">
          <Markdown source={trans(lang, about)} />
        </div>
      </div>
    );
  }
}


